/// <amd-module name="VSSUI/Time" />
export * from "./Components/Time/Time/Time";
export { ITimeProps } from "./Components/Time/Time/Time.Props";
